import api from 'service/api'

const dponetAPI = api.create('dponet')

const list = async ({ dataProcessId, dataTreatmentId }) => {
  return await dponetAPI.get(
    `/data_processes/${dataProcessId}/data_treatments/${dataTreatmentId}/shared_collected_fields`,
  )
}

const create = async ({ dataProcessId, dataTreatmentId, ...params }) => {
  return await dponetAPI.post(
    `/data_processes/${dataProcessId}/data_treatments/${dataTreatmentId}/shared_collected_fields`,
    params,
  )
}

const manage = async ({ dataProcessId, dataTreatmentId, ...params }) => {
  return await dponetAPI.put(
    `/data_processes/${dataProcessId}/data_treatments/${dataTreatmentId}/shared_collected_fields/manage`,
    params,
  )
}

const destroyAll = async ({ dataProcessId, dataTreatmentId, ...params }) => {
  return await dponetAPI.delete(
    `/data_processes/${dataProcessId}/data_treatments/${dataTreatmentId}/shared_collected_fields/destroy_all`,
    { data: params },
  )
}

export default { list, create, manage, destroyAll }
